"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOrUpdateExtraLibFactoryFromJS = exports.AddOrUpdateExtraLibFactory = void 0;
const immutable_1 = require("immutable");
exports.AddOrUpdateExtraLibFactory = (0, immutable_1.Record)({
    content: null,
    fileId: null,
    useAllThisExtension: null,
    includeFileIds: (0, immutable_1.List)()
});
const AddOrUpdateExtraLibFactoryFromJS = function (data) {
    return (0, exports.AddOrUpdateExtraLibFactory)({
        includeFileIds: (0, immutable_1.List)(data.includeFileIds),
        content: data.content,
        fileId: data.fileId,
        useAllThisExtension: data.useAllThisExtension
    });
};
exports.AddOrUpdateExtraLibFactoryFromJS = AddOrUpdateExtraLibFactoryFromJS;
//# sourceMappingURL=IAddOrUpdateExtraLibPayload.js.map